import React from "react";
import { Route, Routes } from "react-router-dom";
import DriverTransferRequestDetailScreen from "screens/App/CRM/Driver/DriverTransferRequestDetailScreen";
import BranchCOCReport from "screens/App/CRM/Reports/PendingCOCBranchReport/BranchCOCReport";
import BranchCODReport from "screens/App/CRM/Reports/PendingCODBranchReport/BranchCODReport";
import BranchReport from "screens/App/CRM/Reports/BranchReport";
import BulkCancelShipmentReportListScreen from "screens/App/CRM/Reports/BulkCancelShipmentReportListScreen";
import DriverSendOutPendingDeliveryListReport from "screens/App/CRM/Reports/DriverSendOutPendingDeliveryListReport";
import MerchantReportListScreen from "screens/App/CRM/Reports/MerchantReportListScreen";
import MisplacedShipmentListScreen from "screens/App/CRM/Reports/MisplacedShipmentListScreen";
import NoPriceShipmentListScreen from "screens/App/CRM/Reports/NoPriceShipmentListScreen";
import COCCollectionReport from "screens/App/CRM/Reports/PaymentReports/COCCollectionReport";
import COCUserReportDetail from "screens/App/CRM/Reports/PaymentReports/COCUserReportDetail";
import CODChargeDeductReport from "screens/App/CRM/Reports/PaymentReports/CODChargeDeductReport";
import CODReport from "screens/App/CRM/Reports/PaymentReports/CODReport";
import DailyTransactionDetail from "screens/App/CRM/Reports/PaymentReports/DailyTransactionDetail";
import DeliveryCollectionReport from "screens/App/CRM/Reports/PaymentReports/DeliveryCollectionReport";
import DeliveryUserReportDetail from "screens/App/CRM/Reports/PaymentReports/DeliveryUserReportDetail";
import MyCOCCollectionReport from "screens/App/CRM/Reports/PaymentReports/MyCOCCollectionReport";
import MyCODCollectionReport from "screens/App/CRM/Reports/PaymentReports/MyCODCollectionReport";
import PendingPaymentsReport from "screens/App/CRM/Reports/PaymentReports/PendingPaymentsReport";
import PriceChangeReport from "screens/App/CRM/Reports/PaymentReports/PriceChangeLogReport";
import QRPaymentReport from "screens/App/CRM/Reports/PaymentReports/QRPaymentReport";
import ShipmentPricingReport from "screens/App/CRM/Reports/PaymentReports/ShipmentPricingReport";
import DailyTransactionReport from "screens/App/CRM/Reports/PaymentReports/TransactionReportDaily";
import UserCOCCollectionReport from "screens/App/CRM/Reports/PaymentReports/UserCOCCollectionReport";
import UserDeliveryCollectionReport from "screens/App/CRM/Reports/PaymentReports/UserDeliveryCollectionReport";
import NoVendorDocsReport from "screens/App/CRM/Reports/PaymentReports/VendorReports/NoVendorDocsReport";
import VendorBranchReport from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorBranchReport";
import VendorDocumentExpiryReport from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorDocumentExpiryReport";
import VendorReport from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorReport";
import VendorRMWiseReport from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorRMWiseReport";
import VendorRMWiseReportDetail from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorRMWiseReportDetail";
import VendorShipmentCount from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorShipmentCountReport";
import VendorTransactionReport from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorTransactionReport";
import VendorTransactionReportDetail from "screens/App/CRM/Reports/PaymentReports/VendorReports/VendorTransactionReportDetail";

import ReportListScreen from "screens/App/CRM/Reports/ReportListScreen";
import ReturnedShipmentReportListScreen from "screens/App/CRM/Reports/ReturnedShipmentReportListScreen";
import ShipmentReportListScreen from "screens/App/CRM/Reports/ShipmentReportListScreen";
import VehicleMileageListScreen from "screens/App/CRM/Reports/VehicleMileageListScreenReport";
import BranchShipmentsReport from "screens/App/CRM/ShipmentRequest/ShipmentComponents/BranchShipmentsReport";
import ShipmentDeliveryReport from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentDeliveryReport";
import StaleShipmentListScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/StaleShipmentList";
import VendorLeadAnalyticsScreen from "screens/App/CRM/VendorLead/vendorLeadReports/VendorLeadAnalyticsScreen";
import VendorLeadNoteListReport from "screens/App/CRM/VendorLead/vendorLeadReports/VendorLeadNoteListReport";
import { VendorLeadResponsibleBreakdownScreen } from "screens/App/CRM/VendorLead/vendorLeadReports/VendorLeadResponsibleBreakdownScreen";
import { VendorLeadResponsibleStatsScreen } from "screens/App/CRM/VendorLead/vendorLeadReports/VendorLeadResponsibleStatsScreen";
import VendorLeadTaskListReport from "screens/App/CRM/VendorLead/vendorLeadReports/VendorLeadTaskListReport";
import VendorLeadStatusLogReport from "screens/App/CRM/VendorLead/Vendorleadstatuslogreport";
import BranchCOCUserSummary from "screens/App/CRM/Reports/PendingCOCBranchReport/BranchCOCUserSummary";
import BranchCOCVendorSummary from "screens/App/CRM/Reports/PendingCOCBranchReport/BranchCOCVendorSummary";
import BranchCOCUserDetail from "screens/App/CRM/Reports/PendingCOCBranchReport/BranchCOCUserDetail";
import BranchCOCVendorDetail from "screens/App/CRM/Reports/PendingCOCBranchReport/BranchCOCVendorDetail";
import BranchCODUserSummary from "screens/App/CRM/Reports/PendingCODBranchReport/BranchCODUserSummary";
import BranchCODUserDetail from "screens/App/CRM/Reports/PendingCODBranchReport/BranchCODUserDetail";
import MergedBranchReport from "screens/App/CRM/Reports/MergedBranchReport/MergedBranchReport";
import GeneralLedgerSalesReport from "screens/App/CRM/Reports/GLReport/GeneralLedgerSalesReport";
import BSLReportListScreen from "screens/App/CRM/BranchShipmentLocation/BSLReportListScreen";
import BSLReportViewScreen from "screens/App/CRM/BranchShipmentLocation/BSLReportViewScreen";
import { ApiPerformanceLogListScreen } from "screens/App/CRM/ApiPerformance/ApiPerformanceLogListScreen";
import { ApiPerformanceGraphScreen } from "screens/App/CRM/ApiPerformance/ApiPerformanceGraphScreen";
import ShipmentChargeReport from "screens/App/CRM/Reports/PaymentReports/ShipmentChargeReport";
import BranchTallyUploadListScreen from "screens/App/CRM/BranchTally/BranchTallyUpload/BranchTallyUploadListScreen";
import BranchTallyUploadCreateScreen from "screens/App/CRM/BranchTally/BranchTallyUpload/BranchTallyUploadCreateScreen";
import BranchTallyUploadEditScreen from "screens/App/CRM/BranchTally/BranchTallyUpload/BranchTallyUploadEditScreen";
import BranchTallyUploadDetailScreen from "screens/App/CRM/BranchTally/BranchTallyUpload/BranchTallyUploadDetailScreen";
import EbillReportListScreen from "screens/App/CRM/Reports/EBillReport/EbillReportListScreen";

const ReportRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<ReportListScreen />} />
      <Route
        path="bulkCancelReport"
        element={<BulkCancelShipmentReportListScreen />}
      />
      <Route
        path="returnedShipmentReport"
        element={<ReturnedShipmentReportListScreen />}
      />
      <Route path="shipment-report" element={<ShipmentReportListScreen />} />
      <Route path="branch-tally-upload/list" element={<BranchTallyUploadListScreen />} />
      <Route path="branch-tally-upload/create" element={<BranchTallyUploadCreateScreen />} />
      <Route path="branch-tally-upload/:id/edit" element={<BranchTallyUploadEditScreen />} />
      <Route path="branch-tally-upload/:id/detail" element={<BranchTallyUploadDetailScreen />} />
      <Route
        path="misplaced-shipment"
        element={<MisplacedShipmentListScreen />}
      />
      <Route path="coc-report" element={<COCCollectionReport />} />
      <Route path="user-coc-report" element={<UserCOCCollectionReport />} />
      <Route path="delivery-report" element={<DeliveryCollectionReport />} />
      <Route
        path="user-delivery-report"
        element={<UserDeliveryCollectionReport />}
      />
      <Route
        path="pending-payment-report"
        element={<PendingPaymentsReport />}
      />
      <Route path="cod-report" element={<CODReport />} />
      <Route path="transaction-report" element={<DailyTransactionReport />} />
      <Route
        path="no-price-shipments"
        element={<NoPriceShipmentListScreen />}
      />
      <Route
        path="shipment-charge-report"
        element={<ShipmentChargeReport />}
      />
      <Route
        path="driver-pending-delivery"
        element={<DriverSendOutPendingDeliveryListReport />}
      />
      <Route
        path="/vendor-lead-analytics"
        element={<VendorLeadAnalyticsScreen />}
      />
      <Route
        path="unattended-shipments"
        element={<StaleShipmentListScreen />}
      />
      <Route
        path="transaction-report/daily-detail/:date"
        element={<DailyTransactionDetail />}
      />

      <Route
        path="coc-report/user/:userId/detail"
        element={<COCUserReportDetail />}
      />
      <Route
        path="/average-delivery-time"
        element={<ShipmentDeliveryReport />}
      />
      <Route
        path="/average-delivery-time/branch/:branchId"
        element={<BranchShipmentsReport />}
      />

      <Route
        path="delivery-report/user/:userId/detail"
        element={<DeliveryUserReportDetail />}
      />

      <Route
        path="my-coc-collection-report"
        element={<MyCOCCollectionReport />}
      />

      <Route
        path="my-cod-collection-report"
        element={<MyCODCollectionReport />}
      />

      <Route
        path="vehicleMileageReport"
        element={<VehicleMileageListScreen />}
      />
      <Route path="merchantReport" element={<MerchantReportListScreen />} />
      <Route
        path="vendor-transaction-report"
        element={<VendorTransactionReport />}
      />
      <Route
        path="getDocumentsExpiry"
        element={<VendorDocumentExpiryReport />}
      />
      <Route
        path="vendor-transaction-report/vendor/:vendorId/detail"
        element={<VendorTransactionReportDetail />}
      />

      <Route path="vendor-no-docs" element={<NoVendorDocsReport />} />
      {/* <Route path="sales-report" element={<SalesReport />} /> */}
      <Route path="branch-report" element={<BranchReport />} />
      <Route path="cod-branch-report" element={<BranchCODReport />} />
      <Route path="coc-branch-report" element={<BranchCOCReport />} />
      <Route path="coc-cod-branch-report" element={<MergedBranchReport />} />
      <Route
        path="branch-coc-user-summary"
        element={<BranchCOCUserSummary />}
      />
      <Route
        path="branch-coc-vendor-summary"
        element={<BranchCOCVendorSummary />}
      />
      <Route path="branch-coc-user-detail" element={<BranchCOCUserDetail />} />
      <Route
        path="branch-coc-vendor-detail"
        element={<BranchCOCVendorDetail />}
      />
      <Route
        path="branch-cod-user-summary"
        element={<BranchCODUserSummary />}
      />
      <Route path="branch-cod-user-detail" element={<BranchCODUserDetail />} />
      <Route path="vendor-branch-report" element={<VendorBranchReport />} />
      <Route path="price-change-report" element={<PriceChangeReport />} />
      <Route path="vendor-report" element={<VendorReport />} />
      <Route path="getVendorShipmentCounts" element={<VendorShipmentCount />} />
      <Route path="vendor-RM-report" element={<VendorRMWiseReport />} />
      <Route
        path="/vendor-RM-report-detail"
        element={<VendorRMWiseReportDetail />}
      />
      <Route
        path="/vendor-lead-note-list"
        element={<VendorLeadNoteListReport />}
      />
      <Route
        path="/vendor-lead-task-note-list"
        element={<VendorLeadTaskListReport />}
      />
      <Route
        path="/vendor-lead-responsible"
        element={<VendorLeadResponsibleStatsScreen />}
      />
      <Route
        path="/vendor-responsible/:responsibleId/breakdown"
        element={<VendorLeadResponsibleBreakdownScreen />}
      />

      <Route path="shipment-pricing" element={<ShipmentPricingReport />} />
      <Route path="/qr-payment-report" element={<QRPaymentReport />} />
      <Route
        path="/vendor-lead-status-log"
        element={<VendorLeadStatusLogReport />}
      />
      <Route
        path="/driver-transfer-request/:id/detail"
        element={<DriverTransferRequestDetailScreen />}
      />
      <Route
        path="cod-charge-deduct-report"
        element={<CODChargeDeductReport />}
      />
      <Route path="general-ledger-sales-report" element={<GeneralLedgerSalesReport />} />
      <Route path="branch-shipment-location-report" element={<BSLReportListScreen />} />
      <Route path="branch-shipment-location-view" element={<BSLReportViewScreen />} />
      <Route path="api-performance-report" element={<ApiPerformanceLogListScreen />} />
    <Route path="api-performance-graph" element={<ApiPerformanceGraphScreen />} />
    <Route path="ebill-report" element={<EbillReportListScreen />} />
    </Routes>
  );
};

export default ReportRouter;
